export default __webpack_public_path__ + "static/media/hike_with_me.d3f4fcfb.PNG";